import Vue from 'vue'
import VueRouter from 'vue-router'
import router_modular from '@/router/router_modular/index.js'
Vue.use(VueRouter)

const routes = [
  ...router_modular
]

const router = new VueRouter({
  base: process.env.NODE_ENV === 'production' ? '/joyplay_web' : '/',
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  routes: routes
})
//全局路由守卫
// router.beforeEach((to,from,next)=>{
//   console.log(to,from);
//   next()
// })
// router.afterEach((to,from)=>{
//   console.log(to,from);
// })
export default router
